import { useEffect, useState } from "react";
import { db, loggedGetDoc } from "../firebase";
import { doc, setDoc } from "firebase/firestore";

export interface AppConfig {
  enableGst?: boolean;
}

const CONFIG_DOC = "appConfig/general";

export function useAppConfig() {
  const [config, setConfig] = useState<AppConfig>({});

  useEffect(() => {
    let ignore = false;
    async function fetch() {
      try {
        const snap = await loggedGetDoc(doc(db, CONFIG_DOC));
        if (!ignore && snap.exists()) {
          setConfig(snap.data() as AppConfig);
        }
      } catch (e) {
        console.warn("Failed to load app config", e);
      }
    }
    fetch();
    return () => {
      ignore = true;
    };
  }, []);

  const saveConfig = async (updates: Partial<AppConfig>) => {
    await setDoc(doc(db, CONFIG_DOC), { ...config, ...updates }, { merge: true });
    setConfig(prev => ({ ...prev, ...updates }));
  };

  return { config, saveConfig };
}
